/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthProfileRouteImport } from './routes/_auth/profile'
import { Route as AuthAddRouteImport } from './routes/_auth/add'
import { Route as AuthAdminRouteImport } from './routes/_auth/_admin'
import { Route as AuthOrdersIndexRouteImport } from './routes/_auth/orders/index'
import { Route as AuthProfileShortageRouteImport } from './routes/_auth/profile/shortage'
import { Route as AuthProfileSewingRouteImport } from './routes/_auth/profile/sewing'
import { Route as AuthProfileEyeletRouteImport } from './routes/_auth/profile/eyelet'
import { Route as AuthProfileCuttingRouteImport } from './routes/_auth/profile/cutting'
import { Route as AuthPlaceChar123PlaceIdChar125RouteImport } from './routes/_auth/place.{-$placeId}'
import { Route as AuthOrdersNewRouteImport } from './routes/_auth/orders/new'
import { Route as AuthAdvancedSearchChar123SectionChar125RouteImport } from './routes/_auth/advanced-search.{-$section}'
import { Route as AuthAdminShortagesRouteImport } from './routes/_auth/_admin/shortages'
import { Route as AuthAdminSettingsRouteImport } from './routes/_auth/_admin/settings'
import { Route as AuthAdminAnalyticsRouteImport } from './routes/_auth/_admin/analytics'
import { Route as AuthAdminAdminRouteImport } from './routes/_auth/_admin/admin'
import { Route as AuthAdminShortagesIndexRouteImport } from './routes/_auth/_admin/shortages/index'
import { Route as AuthProductProductIdChar123SectionChar125RouteImport } from './routes/_auth/product.$productId.{-$section}'
import { Route as AuthOrdersEditOrderNumberRouteImport } from './routes/_auth/orders/edit.$orderNumber'
import { Route as AuthOrdersDetailsOrderNumberRouteImport } from './routes/_auth/orders/details.$orderNumber'
import { Route as AuthAdminShortagesOrdersRouteImport } from './routes/_auth/_admin/shortages/orders'
import { Route as AuthAdminAnalyticsSewingRouteImport } from './routes/_auth/_admin/analytics/sewing'
import { Route as AuthAdminAnalyticsEyeletRouteImport } from './routes/_auth/_admin/analytics/eyelet'
import { Route as AuthAdminAnalyticsCuttingRouteImport } from './routes/_auth/_admin/analytics/cutting'
import { Route as AuthAdminAdminUsersRouteImport } from './routes/_auth/_admin/admin/users'
import { Route as AuthAdminAdminPlacesRouteImport } from './routes/_auth/_admin/admin/places'
import { Route as AuthAdminAdminManufacturersRouteImport } from './routes/_auth/_admin/admin/manufacturers'
import { Route as AuthAdminAdminHistoryRouteImport } from './routes/_auth/_admin/admin/history'
import { Route as AuthAdminAdminDeliveryCompaniesRouteImport } from './routes/_auth/_admin/admin/delivery-companies'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfileRoute = AuthProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAddRoute = AuthAddRouteImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdminRoute = AuthAdminRouteImport.update({
  id: '/_admin',
  getParentRoute: () => AuthRoute,
} as any)
const AuthOrdersIndexRoute = AuthOrdersIndexRouteImport.update({
  id: '/orders/',
  path: '/orders/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthProfileShortageRoute = AuthProfileShortageRouteImport.update({
  id: '/shortage',
  path: '/shortage',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthProfileSewingRoute = AuthProfileSewingRouteImport.update({
  id: '/sewing',
  path: '/sewing',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthProfileEyeletRoute = AuthProfileEyeletRouteImport.update({
  id: '/eyelet',
  path: '/eyelet',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthProfileCuttingRoute = AuthProfileCuttingRouteImport.update({
  id: '/cutting',
  path: '/cutting',
  getParentRoute: () => AuthProfileRoute,
} as any)
const AuthPlaceChar123PlaceIdChar125Route =
  AuthPlaceChar123PlaceIdChar125RouteImport.update({
    id: '/place/{-$placeId}',
    path: '/place/{-$placeId}',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthOrdersNewRoute = AuthOrdersNewRouteImport.update({
  id: '/orders/new',
  path: '/orders/new',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAdvancedSearchChar123SectionChar125Route =
  AuthAdvancedSearchChar123SectionChar125RouteImport.update({
    id: '/advanced-search/{-$section}',
    path: '/advanced-search/{-$section}',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdminShortagesRoute = AuthAdminShortagesRouteImport.update({
  id: '/shortages',
  path: '/shortages',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminSettingsRoute = AuthAdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminAnalyticsRoute = AuthAdminAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminAdminRoute = AuthAdminAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthAdminRoute,
} as any)
const AuthAdminShortagesIndexRoute = AuthAdminShortagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthAdminShortagesRoute,
} as any)
const AuthProductProductIdChar123SectionChar125Route =
  AuthProductProductIdChar123SectionChar125RouteImport.update({
    id: '/product/$productId/{-$section}',
    path: '/product/$productId/{-$section}',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthOrdersEditOrderNumberRoute =
  AuthOrdersEditOrderNumberRouteImport.update({
    id: '/orders/edit/$orderNumber',
    path: '/orders/edit/$orderNumber',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthOrdersDetailsOrderNumberRoute =
  AuthOrdersDetailsOrderNumberRouteImport.update({
    id: '/orders/details/$orderNumber',
    path: '/orders/details/$orderNumber',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthAdminShortagesOrdersRoute =
  AuthAdminShortagesOrdersRouteImport.update({
    id: '/orders',
    path: '/orders',
    getParentRoute: () => AuthAdminShortagesRoute,
  } as any)
const AuthAdminAnalyticsSewingRoute =
  AuthAdminAnalyticsSewingRouteImport.update({
    id: '/sewing',
    path: '/sewing',
    getParentRoute: () => AuthAdminAnalyticsRoute,
  } as any)
const AuthAdminAnalyticsEyeletRoute =
  AuthAdminAnalyticsEyeletRouteImport.update({
    id: '/eyelet',
    path: '/eyelet',
    getParentRoute: () => AuthAdminAnalyticsRoute,
  } as any)
const AuthAdminAnalyticsCuttingRoute =
  AuthAdminAnalyticsCuttingRouteImport.update({
    id: '/cutting',
    path: '/cutting',
    getParentRoute: () => AuthAdminAnalyticsRoute,
  } as any)
const AuthAdminAdminUsersRoute = AuthAdminAdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthAdminAdminRoute,
} as any)
const AuthAdminAdminPlacesRoute = AuthAdminAdminPlacesRouteImport.update({
  id: '/places',
  path: '/places',
  getParentRoute: () => AuthAdminAdminRoute,
} as any)
const AuthAdminAdminManufacturersRoute =
  AuthAdminAdminManufacturersRouteImport.update({
    id: '/manufacturers',
    path: '/manufacturers',
    getParentRoute: () => AuthAdminAdminRoute,
  } as any)
const AuthAdminAdminHistoryRoute = AuthAdminAdminHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AuthAdminAdminRoute,
} as any)
const AuthAdminAdminDeliveryCompaniesRoute =
  AuthAdminAdminDeliveryCompaniesRouteImport.update({
    id: '/delivery-companies',
    path: '/delivery-companies',
    getParentRoute: () => AuthAdminAdminRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/login': typeof LoginRoute
  '/add': typeof AuthAddRoute
  '/profile': typeof AuthProfileRouteWithChildren
  '/admin': typeof AuthAdminAdminRouteWithChildren
  '/analytics': typeof AuthAdminAnalyticsRouteWithChildren
  '/settings': typeof AuthAdminSettingsRoute
  '/shortages': typeof AuthAdminShortagesRouteWithChildren
  '/advanced-search/{-$section}': typeof AuthAdvancedSearchChar123SectionChar125Route
  '/orders/new': typeof AuthOrdersNewRoute
  '/place/{-$placeId}': typeof AuthPlaceChar123PlaceIdChar125Route
  '/profile/cutting': typeof AuthProfileCuttingRoute
  '/profile/eyelet': typeof AuthProfileEyeletRoute
  '/profile/sewing': typeof AuthProfileSewingRoute
  '/profile/shortage': typeof AuthProfileShortageRoute
  '/orders/': typeof AuthOrdersIndexRoute
  '/admin/delivery-companies': typeof AuthAdminAdminDeliveryCompaniesRoute
  '/admin/history': typeof AuthAdminAdminHistoryRoute
  '/admin/manufacturers': typeof AuthAdminAdminManufacturersRoute
  '/admin/places': typeof AuthAdminAdminPlacesRoute
  '/admin/users': typeof AuthAdminAdminUsersRoute
  '/analytics/cutting': typeof AuthAdminAnalyticsCuttingRoute
  '/analytics/eyelet': typeof AuthAdminAnalyticsEyeletRoute
  '/analytics/sewing': typeof AuthAdminAnalyticsSewingRoute
  '/shortages/orders': typeof AuthAdminShortagesOrdersRoute
  '/orders/details/$orderNumber': typeof AuthOrdersDetailsOrderNumberRoute
  '/orders/edit/$orderNumber': typeof AuthOrdersEditOrderNumberRoute
  '/product/$productId/{-$section}': typeof AuthProductProductIdChar123SectionChar125Route
  '/shortages/': typeof AuthAdminShortagesIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/': typeof AuthIndexRoute
  '/add': typeof AuthAddRoute
  '/profile': typeof AuthProfileRouteWithChildren
  '/admin': typeof AuthAdminAdminRouteWithChildren
  '/analytics': typeof AuthAdminAnalyticsRouteWithChildren
  '/settings': typeof AuthAdminSettingsRoute
  '/advanced-search/{-$section}': typeof AuthAdvancedSearchChar123SectionChar125Route
  '/orders/new': typeof AuthOrdersNewRoute
  '/place/{-$placeId}': typeof AuthPlaceChar123PlaceIdChar125Route
  '/profile/cutting': typeof AuthProfileCuttingRoute
  '/profile/eyelet': typeof AuthProfileEyeletRoute
  '/profile/sewing': typeof AuthProfileSewingRoute
  '/profile/shortage': typeof AuthProfileShortageRoute
  '/orders': typeof AuthOrdersIndexRoute
  '/admin/delivery-companies': typeof AuthAdminAdminDeliveryCompaniesRoute
  '/admin/history': typeof AuthAdminAdminHistoryRoute
  '/admin/manufacturers': typeof AuthAdminAdminManufacturersRoute
  '/admin/places': typeof AuthAdminAdminPlacesRoute
  '/admin/users': typeof AuthAdminAdminUsersRoute
  '/analytics/cutting': typeof AuthAdminAnalyticsCuttingRoute
  '/analytics/eyelet': typeof AuthAdminAnalyticsEyeletRoute
  '/analytics/sewing': typeof AuthAdminAnalyticsSewingRoute
  '/shortages/orders': typeof AuthAdminShortagesOrdersRoute
  '/orders/details/$orderNumber': typeof AuthOrdersDetailsOrderNumberRoute
  '/orders/edit/$orderNumber': typeof AuthOrdersEditOrderNumberRoute
  '/product/$productId/{-$section}': typeof AuthProductProductIdChar123SectionChar125Route
  '/shortages': typeof AuthAdminShortagesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/login': typeof LoginRoute
  '/_auth/_admin': typeof AuthAdminRouteWithChildren
  '/_auth/add': typeof AuthAddRoute
  '/_auth/profile': typeof AuthProfileRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/_auth/_admin/admin': typeof AuthAdminAdminRouteWithChildren
  '/_auth/_admin/analytics': typeof AuthAdminAnalyticsRouteWithChildren
  '/_auth/_admin/settings': typeof AuthAdminSettingsRoute
  '/_auth/_admin/shortages': typeof AuthAdminShortagesRouteWithChildren
  '/_auth/advanced-search/{-$section}': typeof AuthAdvancedSearchChar123SectionChar125Route
  '/_auth/orders/new': typeof AuthOrdersNewRoute
  '/_auth/place/{-$placeId}': typeof AuthPlaceChar123PlaceIdChar125Route
  '/_auth/profile/cutting': typeof AuthProfileCuttingRoute
  '/_auth/profile/eyelet': typeof AuthProfileEyeletRoute
  '/_auth/profile/sewing': typeof AuthProfileSewingRoute
  '/_auth/profile/shortage': typeof AuthProfileShortageRoute
  '/_auth/orders/': typeof AuthOrdersIndexRoute
  '/_auth/_admin/admin/delivery-companies': typeof AuthAdminAdminDeliveryCompaniesRoute
  '/_auth/_admin/admin/history': typeof AuthAdminAdminHistoryRoute
  '/_auth/_admin/admin/manufacturers': typeof AuthAdminAdminManufacturersRoute
  '/_auth/_admin/admin/places': typeof AuthAdminAdminPlacesRoute
  '/_auth/_admin/admin/users': typeof AuthAdminAdminUsersRoute
  '/_auth/_admin/analytics/cutting': typeof AuthAdminAnalyticsCuttingRoute
  '/_auth/_admin/analytics/eyelet': typeof AuthAdminAnalyticsEyeletRoute
  '/_auth/_admin/analytics/sewing': typeof AuthAdminAnalyticsSewingRoute
  '/_auth/_admin/shortages/orders': typeof AuthAdminShortagesOrdersRoute
  '/_auth/orders/details/$orderNumber': typeof AuthOrdersDetailsOrderNumberRoute
  '/_auth/orders/edit/$orderNumber': typeof AuthOrdersEditOrderNumberRoute
  '/_auth/product/$productId/{-$section}': typeof AuthProductProductIdChar123SectionChar125Route
  '/_auth/_admin/shortages/': typeof AuthAdminShortagesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/add'
    | '/profile'
    | '/admin'
    | '/analytics'
    | '/settings'
    | '/shortages'
    | '/advanced-search/{-$section}'
    | '/orders/new'
    | '/place/{-$placeId}'
    | '/profile/cutting'
    | '/profile/eyelet'
    | '/profile/sewing'
    | '/profile/shortage'
    | '/orders/'
    | '/admin/delivery-companies'
    | '/admin/history'
    | '/admin/manufacturers'
    | '/admin/places'
    | '/admin/users'
    | '/analytics/cutting'
    | '/analytics/eyelet'
    | '/analytics/sewing'
    | '/shortages/orders'
    | '/orders/details/$orderNumber'
    | '/orders/edit/$orderNumber'
    | '/product/$productId/{-$section}'
    | '/shortages/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/'
    | '/add'
    | '/profile'
    | '/admin'
    | '/analytics'
    | '/settings'
    | '/advanced-search/{-$section}'
    | '/orders/new'
    | '/place/{-$placeId}'
    | '/profile/cutting'
    | '/profile/eyelet'
    | '/profile/sewing'
    | '/profile/shortage'
    | '/orders'
    | '/admin/delivery-companies'
    | '/admin/history'
    | '/admin/manufacturers'
    | '/admin/places'
    | '/admin/users'
    | '/analytics/cutting'
    | '/analytics/eyelet'
    | '/analytics/sewing'
    | '/shortages/orders'
    | '/orders/details/$orderNumber'
    | '/orders/edit/$orderNumber'
    | '/product/$productId/{-$section}'
    | '/shortages'
  id:
    | '__root__'
    | '/_auth'
    | '/login'
    | '/_auth/_admin'
    | '/_auth/add'
    | '/_auth/profile'
    | '/_auth/'
    | '/_auth/_admin/admin'
    | '/_auth/_admin/analytics'
    | '/_auth/_admin/settings'
    | '/_auth/_admin/shortages'
    | '/_auth/advanced-search/{-$section}'
    | '/_auth/orders/new'
    | '/_auth/place/{-$placeId}'
    | '/_auth/profile/cutting'
    | '/_auth/profile/eyelet'
    | '/_auth/profile/sewing'
    | '/_auth/profile/shortage'
    | '/_auth/orders/'
    | '/_auth/_admin/admin/delivery-companies'
    | '/_auth/_admin/admin/history'
    | '/_auth/_admin/admin/manufacturers'
    | '/_auth/_admin/admin/places'
    | '/_auth/_admin/admin/users'
    | '/_auth/_admin/analytics/cutting'
    | '/_auth/_admin/analytics/eyelet'
    | '/_auth/_admin/analytics/sewing'
    | '/_auth/_admin/shortages/orders'
    | '/_auth/orders/details/$orderNumber'
    | '/_auth/orders/edit/$orderNumber'
    | '/_auth/product/$productId/{-$section}'
    | '/_auth/_admin/shortages/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profile': {
      id: '/_auth/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthProfileRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/add': {
      id: '/_auth/add'
      path: '/add'
      fullPath: '/add'
      preLoaderRoute: typeof AuthAddRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_admin': {
      id: '/_auth/_admin'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthAdminRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/orders/': {
      id: '/_auth/orders/'
      path: '/orders'
      fullPath: '/orders/'
      preLoaderRoute: typeof AuthOrdersIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/profile/shortage': {
      id: '/_auth/profile/shortage'
      path: '/shortage'
      fullPath: '/profile/shortage'
      preLoaderRoute: typeof AuthProfileShortageRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/profile/sewing': {
      id: '/_auth/profile/sewing'
      path: '/sewing'
      fullPath: '/profile/sewing'
      preLoaderRoute: typeof AuthProfileSewingRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/profile/eyelet': {
      id: '/_auth/profile/eyelet'
      path: '/eyelet'
      fullPath: '/profile/eyelet'
      preLoaderRoute: typeof AuthProfileEyeletRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/profile/cutting': {
      id: '/_auth/profile/cutting'
      path: '/cutting'
      fullPath: '/profile/cutting'
      preLoaderRoute: typeof AuthProfileCuttingRouteImport
      parentRoute: typeof AuthProfileRoute
    }
    '/_auth/place/{-$placeId}': {
      id: '/_auth/place/{-$placeId}'
      path: '/place/{-$placeId}'
      fullPath: '/place/{-$placeId}'
      preLoaderRoute: typeof AuthPlaceChar123PlaceIdChar125RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/orders/new': {
      id: '/_auth/orders/new'
      path: '/orders/new'
      fullPath: '/orders/new'
      preLoaderRoute: typeof AuthOrdersNewRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/advanced-search/{-$section}': {
      id: '/_auth/advanced-search/{-$section}'
      path: '/advanced-search/{-$section}'
      fullPath: '/advanced-search/{-$section}'
      preLoaderRoute: typeof AuthAdvancedSearchChar123SectionChar125RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_admin/shortages': {
      id: '/_auth/_admin/shortages'
      path: '/shortages'
      fullPath: '/shortages'
      preLoaderRoute: typeof AuthAdminShortagesRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/settings': {
      id: '/_auth/_admin/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthAdminSettingsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/analytics': {
      id: '/_auth/_admin/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthAdminAnalyticsRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/admin': {
      id: '/_auth/_admin/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthAdminAdminRouteImport
      parentRoute: typeof AuthAdminRoute
    }
    '/_auth/_admin/shortages/': {
      id: '/_auth/_admin/shortages/'
      path: '/'
      fullPath: '/shortages/'
      preLoaderRoute: typeof AuthAdminShortagesIndexRouteImport
      parentRoute: typeof AuthAdminShortagesRoute
    }
    '/_auth/product/$productId/{-$section}': {
      id: '/_auth/product/$productId/{-$section}'
      path: '/product/$productId/{-$section}'
      fullPath: '/product/$productId/{-$section}'
      preLoaderRoute: typeof AuthProductProductIdChar123SectionChar125RouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/orders/edit/$orderNumber': {
      id: '/_auth/orders/edit/$orderNumber'
      path: '/orders/edit/$orderNumber'
      fullPath: '/orders/edit/$orderNumber'
      preLoaderRoute: typeof AuthOrdersEditOrderNumberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/orders/details/$orderNumber': {
      id: '/_auth/orders/details/$orderNumber'
      path: '/orders/details/$orderNumber'
      fullPath: '/orders/details/$orderNumber'
      preLoaderRoute: typeof AuthOrdersDetailsOrderNumberRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/_admin/shortages/orders': {
      id: '/_auth/_admin/shortages/orders'
      path: '/orders'
      fullPath: '/shortages/orders'
      preLoaderRoute: typeof AuthAdminShortagesOrdersRouteImport
      parentRoute: typeof AuthAdminShortagesRoute
    }
    '/_auth/_admin/analytics/sewing': {
      id: '/_auth/_admin/analytics/sewing'
      path: '/sewing'
      fullPath: '/analytics/sewing'
      preLoaderRoute: typeof AuthAdminAnalyticsSewingRouteImport
      parentRoute: typeof AuthAdminAnalyticsRoute
    }
    '/_auth/_admin/analytics/eyelet': {
      id: '/_auth/_admin/analytics/eyelet'
      path: '/eyelet'
      fullPath: '/analytics/eyelet'
      preLoaderRoute: typeof AuthAdminAnalyticsEyeletRouteImport
      parentRoute: typeof AuthAdminAnalyticsRoute
    }
    '/_auth/_admin/analytics/cutting': {
      id: '/_auth/_admin/analytics/cutting'
      path: '/cutting'
      fullPath: '/analytics/cutting'
      preLoaderRoute: typeof AuthAdminAnalyticsCuttingRouteImport
      parentRoute: typeof AuthAdminAnalyticsRoute
    }
    '/_auth/_admin/admin/users': {
      id: '/_auth/_admin/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AuthAdminAdminUsersRouteImport
      parentRoute: typeof AuthAdminAdminRoute
    }
    '/_auth/_admin/admin/places': {
      id: '/_auth/_admin/admin/places'
      path: '/places'
      fullPath: '/admin/places'
      preLoaderRoute: typeof AuthAdminAdminPlacesRouteImport
      parentRoute: typeof AuthAdminAdminRoute
    }
    '/_auth/_admin/admin/manufacturers': {
      id: '/_auth/_admin/admin/manufacturers'
      path: '/manufacturers'
      fullPath: '/admin/manufacturers'
      preLoaderRoute: typeof AuthAdminAdminManufacturersRouteImport
      parentRoute: typeof AuthAdminAdminRoute
    }
    '/_auth/_admin/admin/history': {
      id: '/_auth/_admin/admin/history'
      path: '/history'
      fullPath: '/admin/history'
      preLoaderRoute: typeof AuthAdminAdminHistoryRouteImport
      parentRoute: typeof AuthAdminAdminRoute
    }
    '/_auth/_admin/admin/delivery-companies': {
      id: '/_auth/_admin/admin/delivery-companies'
      path: '/delivery-companies'
      fullPath: '/admin/delivery-companies'
      preLoaderRoute: typeof AuthAdminAdminDeliveryCompaniesRouteImport
      parentRoute: typeof AuthAdminAdminRoute
    }
  }
}

interface AuthAdminAdminRouteChildren {
  AuthAdminAdminDeliveryCompaniesRoute: typeof AuthAdminAdminDeliveryCompaniesRoute
  AuthAdminAdminHistoryRoute: typeof AuthAdminAdminHistoryRoute
  AuthAdminAdminManufacturersRoute: typeof AuthAdminAdminManufacturersRoute
  AuthAdminAdminPlacesRoute: typeof AuthAdminAdminPlacesRoute
  AuthAdminAdminUsersRoute: typeof AuthAdminAdminUsersRoute
}

const AuthAdminAdminRouteChildren: AuthAdminAdminRouteChildren = {
  AuthAdminAdminDeliveryCompaniesRoute: AuthAdminAdminDeliveryCompaniesRoute,
  AuthAdminAdminHistoryRoute: AuthAdminAdminHistoryRoute,
  AuthAdminAdminManufacturersRoute: AuthAdminAdminManufacturersRoute,
  AuthAdminAdminPlacesRoute: AuthAdminAdminPlacesRoute,
  AuthAdminAdminUsersRoute: AuthAdminAdminUsersRoute,
}

const AuthAdminAdminRouteWithChildren = AuthAdminAdminRoute._addFileChildren(
  AuthAdminAdminRouteChildren,
)

interface AuthAdminAnalyticsRouteChildren {
  AuthAdminAnalyticsCuttingRoute: typeof AuthAdminAnalyticsCuttingRoute
  AuthAdminAnalyticsEyeletRoute: typeof AuthAdminAnalyticsEyeletRoute
  AuthAdminAnalyticsSewingRoute: typeof AuthAdminAnalyticsSewingRoute
}

const AuthAdminAnalyticsRouteChildren: AuthAdminAnalyticsRouteChildren = {
  AuthAdminAnalyticsCuttingRoute: AuthAdminAnalyticsCuttingRoute,
  AuthAdminAnalyticsEyeletRoute: AuthAdminAnalyticsEyeletRoute,
  AuthAdminAnalyticsSewingRoute: AuthAdminAnalyticsSewingRoute,
}

const AuthAdminAnalyticsRouteWithChildren =
  AuthAdminAnalyticsRoute._addFileChildren(AuthAdminAnalyticsRouteChildren)

interface AuthAdminShortagesRouteChildren {
  AuthAdminShortagesOrdersRoute: typeof AuthAdminShortagesOrdersRoute
  AuthAdminShortagesIndexRoute: typeof AuthAdminShortagesIndexRoute
}

const AuthAdminShortagesRouteChildren: AuthAdminShortagesRouteChildren = {
  AuthAdminShortagesOrdersRoute: AuthAdminShortagesOrdersRoute,
  AuthAdminShortagesIndexRoute: AuthAdminShortagesIndexRoute,
}

const AuthAdminShortagesRouteWithChildren =
  AuthAdminShortagesRoute._addFileChildren(AuthAdminShortagesRouteChildren)

interface AuthAdminRouteChildren {
  AuthAdminAdminRoute: typeof AuthAdminAdminRouteWithChildren
  AuthAdminAnalyticsRoute: typeof AuthAdminAnalyticsRouteWithChildren
  AuthAdminSettingsRoute: typeof AuthAdminSettingsRoute
  AuthAdminShortagesRoute: typeof AuthAdminShortagesRouteWithChildren
}

const AuthAdminRouteChildren: AuthAdminRouteChildren = {
  AuthAdminAdminRoute: AuthAdminAdminRouteWithChildren,
  AuthAdminAnalyticsRoute: AuthAdminAnalyticsRouteWithChildren,
  AuthAdminSettingsRoute: AuthAdminSettingsRoute,
  AuthAdminShortagesRoute: AuthAdminShortagesRouteWithChildren,
}

const AuthAdminRouteWithChildren = AuthAdminRoute._addFileChildren(
  AuthAdminRouteChildren,
)

interface AuthProfileRouteChildren {
  AuthProfileCuttingRoute: typeof AuthProfileCuttingRoute
  AuthProfileEyeletRoute: typeof AuthProfileEyeletRoute
  AuthProfileSewingRoute: typeof AuthProfileSewingRoute
  AuthProfileShortageRoute: typeof AuthProfileShortageRoute
}

const AuthProfileRouteChildren: AuthProfileRouteChildren = {
  AuthProfileCuttingRoute: AuthProfileCuttingRoute,
  AuthProfileEyeletRoute: AuthProfileEyeletRoute,
  AuthProfileSewingRoute: AuthProfileSewingRoute,
  AuthProfileShortageRoute: AuthProfileShortageRoute,
}

const AuthProfileRouteWithChildren = AuthProfileRoute._addFileChildren(
  AuthProfileRouteChildren,
)

interface AuthRouteChildren {
  AuthAdminRoute: typeof AuthAdminRouteWithChildren
  AuthAddRoute: typeof AuthAddRoute
  AuthProfileRoute: typeof AuthProfileRouteWithChildren
  AuthIndexRoute: typeof AuthIndexRoute
  AuthAdvancedSearchChar123SectionChar125Route: typeof AuthAdvancedSearchChar123SectionChar125Route
  AuthOrdersNewRoute: typeof AuthOrdersNewRoute
  AuthPlaceChar123PlaceIdChar125Route: typeof AuthPlaceChar123PlaceIdChar125Route
  AuthOrdersIndexRoute: typeof AuthOrdersIndexRoute
  AuthOrdersDetailsOrderNumberRoute: typeof AuthOrdersDetailsOrderNumberRoute
  AuthOrdersEditOrderNumberRoute: typeof AuthOrdersEditOrderNumberRoute
  AuthProductProductIdChar123SectionChar125Route: typeof AuthProductProductIdChar123SectionChar125Route
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthAdminRoute: AuthAdminRouteWithChildren,
  AuthAddRoute: AuthAddRoute,
  AuthProfileRoute: AuthProfileRouteWithChildren,
  AuthIndexRoute: AuthIndexRoute,
  AuthAdvancedSearchChar123SectionChar125Route:
    AuthAdvancedSearchChar123SectionChar125Route,
  AuthOrdersNewRoute: AuthOrdersNewRoute,
  AuthPlaceChar123PlaceIdChar125Route: AuthPlaceChar123PlaceIdChar125Route,
  AuthOrdersIndexRoute: AuthOrdersIndexRoute,
  AuthOrdersDetailsOrderNumberRoute: AuthOrdersDetailsOrderNumberRoute,
  AuthOrdersEditOrderNumberRoute: AuthOrdersEditOrderNumberRoute,
  AuthProductProductIdChar123SectionChar125Route:
    AuthProductProductIdChar123SectionChar125Route,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
